export default "<p>spot works!</p>\n";